module.exports = __webpack_public_path__ + "static/img/bill.ec906f92.png";